import React from 'react'
import MyMedicineUploadFailure from '../Components/MyMedicineUploadFailure/MyMedicineUploadFailure'

const MyMedicineUploadFailureView = () => {
  return (
    <div>
        <MyMedicineUploadFailure />
    </div>
  )
}

export default MyMedicineUploadFailureView